import { useLayoutEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";

import KeyPointsPage from "./keypoints/KeyPointsPage";
import ReadingPage from "./reading/ReadingPage";
import DirectTranslationPage from "./direct_translation/DirectTranslationPage";
import FlowPage from "./flow/FlowPage";
import SentenceTestPage from "./sentence_test/SentenceTestPage";
import VocabularyPage from "./vocabulary/VocabularyPage";
import SyntaxAnalysisPage from "./syntax_analysis/SyntaxAnalysisPage";
import GrammarPage from "../grammar/GrammarPage";
import StepsBar from "../widgets/StepsBar";

/**
 * 지문분석의 '문법' 단계. 문제뱅크 문법과 같은 어법 화면(GrammarPage)을 쓰고, 다른 지문분석
 * 단계처럼 위에 단계 바를 얹는다. 어법 화면은 스스로 화면 높이를 다 쓰므로, 얹은 단계 바
 * 높이만큼 --study-extra-offset 으로 줄여 준다(textUtils.getContentHeight).
 */
const AnalysisGrammarStep = (props) => {
  const barBoxRef = useRef(null);
  const [barHeight, setBarHeight] = useState(0);

  useLayoutEffect(() => {
    const box = barBoxRef.current;
    if (!box) return undefined;
    const measure = () => setBarHeight(box.offsetHeight);
    measure();
    window.addEventListener("resize", measure);
    return () => window.removeEventListener("resize", measure);
  }, []);

  return (
    <div style={{ "--study-extra-offset": `${barHeight}px` }}>
      <div ref={barBoxRef}>
        <StepsBar />
      </div>
      <GrammarPage {...props} />
    </div>
  );
};

const AnalysisPage = ({ setCurrentStep, isPreview, isReview }) => {
  const { section } = useSelector((state) => state.assignment);

  if (section.type === "keypoints") {
    return (
      <KeyPointsPage
        setCurrentStep={setCurrentStep}
        isPreview={isPreview}
        isReview={isReview}
      />
    );
  } else if (section.type === "reading") {
    return (
      <ReadingPage
        setCurrentStep={setCurrentStep}
        isPreview={isPreview}
        isReview={isReview}
      />
    );
  } else if (section.type === "direct_translation") {
    return (
      <DirectTranslationPage
        setCurrentStep={setCurrentStep}
        isPreview={isPreview}
        isReview={isReview}
      />
    );
  } else if (section.type === "flow") {
    return (
      <FlowPage
        setCurrentStep={setCurrentStep}
        isPreview={isPreview}
        isReview={isReview}
      />
    );
  } else if (section.type === "sentence_test") {
    return (
      <SentenceTestPage
        setCurrentStep={setCurrentStep}
        isPreview={isPreview}
        isReview={isReview}
      />
    );
  } else if (section.type === "words") {
    return (
      <VocabularyPage
        setCurrentStep={setCurrentStep}
        isPreview={isPreview}
        isReview={isReview}
      />
    );
  } else if (section.type === "syntax_analysis") {
    return (
      <SyntaxAnalysisPage
        setCurrentStep={setCurrentStep}
        isPreview={isPreview}
        isReview={isReview}
      />
    );
  } else if (section.type === "grammar") {
    return (
      <AnalysisGrammarStep
        setCurrentStep={setCurrentStep}
        isPreview={isPreview}
        isReview={isReview}
      />
    );
  }

  return (
    <div>
      <h1>Section Page</h1>
    </div>
  );
};

export default AnalysisPage;
